import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
//import { useNavigate } from "react-router-dom";

interface UpdateProductProductProps {
  loading: boolean;
  disabled?: boolean;
  onBack: () => void;
  onSaveAndBack: () => void;
}

const UpdateProductProduct : FC<UpdateProductProductProps> = ({ loading, disabled = false, onBack, onSaveAndBack }) => {

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
        <Button
            loading={loading}
            htmlType="button"
            type="default"
            style={{ width: 180 }}
            onClick={onBack}
            size="large"
          >
            ยกเลิก
          </Button>
          <Button
            loading={loading}
            htmlType="submit"
            type="primary"
            style={{ width: 180 }}
            size="large"
            disabled={disabled}
          >
            บันทึก
          </Button>
          <Button
            loading={loading}
            htmlType="button"
            type="primary"
            style={{ width: 180 }}
            onClick={onSaveAndBack}
            size="large"
            disabled={disabled}
          >
            บันทึกและปิด
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default UpdateProductProduct;

const ButtonWrapper = styled.div`
  max-width: 620px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
